import { render, staticRenderFns } from "./rulebasedreal.vue?vue&type=template&id=319f6e5c&"
import script from "./rulebasedreal.vue?vue&type=script&lang=js&"
export * from "./rulebasedreal.vue?vue&type=script&lang=js&"
import style0 from "./rulebasedreal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports